import { useEffect, useState } from "react";
import { _RemoteAbstractAction, _single } from "../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../core/services/dataBean/useDataBean"

interface Props {
    label?: string;
    name?: string;
    idSelect: number | null;
    onChange: Function;
}
export const MonthConstantsEditor = ({ idSelect, label, name, onChange }: Props) => {

    const { lista, setLista, instance } = useDataBean(_RemoteAbstractAction);
    const [id, setId] = useState<number>(null);

    useEffect(() => {
        instance.getMonthConstantsList().then(
            (resp: any) => {
                setLista(resp);
            }
        )
    }, [])

    useEffect(() => {
        if (idSelect != id) {
            setId(idSelect);
        }
    }, [idSelect])

    const setValue = (e: any) => {
        setId(e);
        onChange(e);
    }

    return (
        <>
            <label>{label ?? ''}</label>
            <select name={name} className="form-select" value={id} onChange={(e) => { setValue(parseInt(e.target.value)) }}>
                <option value={NaN}>...</option>
                {lista.map((item: any, index: number) => {
                    return (
                        <option key={index} value={item.DataBeanProperties.Value}>{item.DataBeanProperties.Property}</option>
                    )
                })}
            </select>
        </>
    )
}